import Cookies from 'js-cookie'

// 存储相关工具函数
export const storageUtils = {
  // 清理所有用户相关的存储数据
  clearUserData() {
    // 清理cookies（保留language）
    const cookiesToRemove = [
      'token',
      'userName', 
      'userToken',
      'userInfo'
    ]
    
    cookiesToRemove.forEach(key => {
      Cookies.remove(key)
    })
    
    // 清理localStorage（保留language）
    const localStorageKeysToRemove = [
      'token',
      'userName',
      'userToken', 
      'userInfo'
    ]
    
    localStorageKeysToRemove.forEach(key => {
      localStorage.removeItem(key)
    })
    
    // 清理sessionStorage
    const sessionStorageKeysToRemove = [
      'token',
      'userName',
      'userToken',
      'userInfo'
    ]
    
    sessionStorageKeysToRemove.forEach(key => {
      sessionStorage.removeItem(key)
    })
  },
  
  // 设置用户数据
  setUserData(userData) {
    const { token, userName } = userData
    
    if (token) {
      Cookies.set('token', token, { expires: 7 })
      Cookies.set('userToken', token, { expires: 7 })
      localStorage.setItem('token', token)
      localStorage.setItem('userToken', token)
    }
    
    if (userName) {
      Cookies.set('userName', userName, { expires: 7 })
      localStorage.setItem('userName', userName)
    }
  },
  
  // 获取用户数据
  getUserData() {
    return {
      token: Cookies.get('token') || localStorage.getItem('token'),
      userName: Cookies.get('userName') || localStorage.getItem('userName'),
      userToken: Cookies.get('userToken') || localStorage.getItem('userToken')
    }
  },
  
  // 语言管理
  setLanguage(language) {
    localStorage.setItem('language', language)
    // 也可以存储到cookies，但通常localStorage就足够了
    Cookies.set('language', language, { expires: 365 }) // 1年过期
  },
  
  getLanguage() {
    const supported = ['zh', 'en', 'es']
    const stored = localStorage.getItem('language') || Cookies.get('language') || 'zh'
    return supported.includes(stored) ? stored : 'zh'
  }
}
